import React, { ReactNode } from "react"
import { FormikProps } from "formik/dist/types"
import clsx from "clsx"
import { ObjectSchema } from "yup"
import useFormik from "./useFormik" // Ensure this path is correct for your project

const MyRadiosWithLabelAndDescriptionFormField: React.FC<IPropsModel> = ({
     label,
     name,
     formikProps,
     radios,
     autoFocus,
     classNameLayout,
     classNameLabel,
     classNameField,
     validationSchema,
     onChangeCallback,
}) => {
     const { isFieldOnError, getFieldErrorMessage, isFieldRequired } = useFormik()

     return (
          <>
               <div className={clsx("row", classNameLayout)}>
                    <div className={clsx("col-12 d-flex align-items-center", classNameLabel)}>
                         {label && (
                              <label className={`fs-6 fw-bolder text-gray-900 ${validationSchema && isFieldRequired(validationSchema, name) ? "required" : ""}`}>{label}</label>
                         )}
                    </div>
                    <div className={"col mt-1"}>
                         <div className="row gy-4 gx-4">
                              {radios.map((radio, key) => {
                                   const isChecked = formikProps?.values[name] === radio.radioValue
                                   // Default to col-md-6 (side-by-side) unless classNameField is explicitly provided
                                   const columnClass = classNameField || "col-12 col-md-6"

                                   return (
                                        <div className={columnClass} key={key}>
                                             <label
                                                  className={clsx("btn btn-outline btn-outline-dashed d-flex flex-stack cursor-pointer h-100 p-4", {
                                                       "border-primary": isChecked,
                                                       "border-danger": formikProps && isFieldOnError(formikProps, name),
                                                  })}
                                             >
                                                  <span className="me-2 d-flex align-items-center">
                                                       <span className="symbol symbol-50px me-6">
                                                            <span className={`symbol-label bg-${radio.iconWrapperColor}`}>
                                                                 <i className={clsx(`fas fa-${radio.faIcon}`, "fs-2", `text-${radio.iconColor || "dark"}`)} />
                                                            </span>
                                                       </span>

                                                       <div className="d-flex flex-column text-start">
                                                            <div className="fw-bolder fs-6 d-flex flex-column">{radio.label}</div>

                                                            <div className="flex-column align-items-end">
                                                                 {radio.description && <div className="fs-7 text-muted d-flex flex-column">{radio.description}</div>}
                                                            </div>
                                                       </div>
                                                  </span>

                                                  <span className="form-check form-check-custom form-check-solid">
                                                       <input
                                                            {...formikProps?.getFieldProps(name)}
                                                            type="radio"
                                                            name={name}
                                                            value={radio.radioValue}
                                                            checked={isChecked}
                                                            className={clsx("form-check-input border border-primary", {
                                                                 "border-danger": formikProps && isFieldOnError(formikProps, name),
                                                            })}
                                                            autoFocus={autoFocus}
                                                            onChange={() => {
                                                                 formikProps?.setFieldValue(name, radio.radioValue)
                                                                 if (onChangeCallback) {
                                                                      onChangeCallback(radio.radioValue)
                                                                 }
                                                            }}
                                                       />
                                                  </span>
                                             </label>
                                        </div>
                                   )
                              })}
                         </div>
                    </div>

                    {formikProps && isFieldOnError(formikProps, name) && <div className="text-danger mt-2">{getFieldErrorMessage(formikProps, name)}</div>}
               </div>
          </>
     )
}

interface IPropsModel {
     name: string
     autoFocus?: boolean
     formikProps: FormikProps<any>
     label?: ReactNode
     radios: Array<{
          label: string | ReactNode
          description?: string | ReactNode
          faIcon: string
          radioValue: string | number
          iconColor?: "primary" | "danger" | "warning" | "info" | "success" | "dark" | "white" | "light-primary" | "light-danger" | "light-warning" | "light-info" | "light-success"
          iconWrapperColor?:
               | "primary"
               | "danger"
               | "warning"
               | "info"
               | "success"
               | "dark"
               | "white"
               | "light-primary"
               | "light-danger"
               | "light-warning"
               | "light-info"
               | "light-success"
     }>
     classNameLayout?: string
     classNameLabel?: string
     classNameField?: string
     validationSchema?: ObjectSchema<any>
     onChangeCallback?: (value: string | number) => void
}

export default MyRadiosWithLabelAndDescriptionFormField
